import { createRecentVersionData } from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type { IAutomatedProductListNode, Paint, PartialNode } from "../type";

const defaultPaint: Paint[] = [
  {
    type: "SOLID",
    visible: false,
    color: {
      r: 255,
      g: 255,
      b: 255,
    },
    opacity: 0.25,
  },
  {
    type: "IMAGE",
    visible: false,
    fileType: "png",
    path: "",
    backgroundSize: "COVER",
  },
  {
    type: "SOLID",
    visible: true,
    color: {
      r: 255,
      g: 255,
      b: 255,
    },
    opacity: 1,
  },
];

const createAutomatedProductListNode = (
  data?: PartialNode<IAutomatedProductListNode>
): IAutomatedProductListNode => {
  // swiper-container에서 배경색을 사용함에 따라 기존 swiper-container의 fills가 빈배열이라면 기본값을 채워줌
  const fields = createRecentVersionData(data);
  const result: IAutomatedProductListNode = {
    type: "AUTOMATED_PRODUCT_LIST",
    id: shortUUID.generate(),
    source: { type: "HMALL_BROAD_PRODUCT_LIST" },
    dataAlias: "hmall_live_broad_product_list",
    pluginData: { contentEditorPropSeq: 0 },

    cellWidth: {
      type: "MIN",
      value: 300,
    },

    productCardDirection: "ROW",
    productCardBackgroundColor: {
      r: 255,
      g: 255,
      b: 255,
      a: 1,
    },
    productCardBorderRadius: {
      tl: { unit: "px", value: 16 },
      tr: { unit: "px", value: 16 },
      bl: { unit: "px", value: 16 },
      br: { unit: "px", value: 16 },
    },
    productCardPadding: {
      top: { unit: "px", value: 12 },
      right: { unit: "px", value: 12 },
      bottom: { unit: "px", value: 12 },
      left: { unit: "px", value: 12 },
    },

    imageCornerRadius: {
      tl: { unit: "px", value: 8 },
      tr: { unit: "px", value: 8 },
      bl: { unit: "px", value: 8 },
      br: { unit: "px", value: 8 },
    },

    textContainerPadding: {
      top: { unit: "px", value: 0 },
      right: { unit: "px", value: 0 },
      bottom: { unit: "px", value: 0 },
      left: { unit: "px", value: 8 },
    },

    originalPriceColor: {
      r: 152,
      g: 158,
      b: 150,
      a: 1,
    },
    originalPriceMarginTop: { unit: "px", value: 4 },

    priceContainerMarginTop: { unit: "px", value: 4 },
    priceContainerGap: 4,

    finalPriceColor: {
      r: 27,
      g: 28,
      b: 27,
      a: 1,
    },

    discountRatioColor: {
      r: 255,
      g: 88,
      b: 25,
      a: 1,
    },
    position: { type: "RELATIVE" },
    reactions: [],
    name: "자동화 상품 리스트",

    width: {
      value: 100,
      unit: "%",
    },

    locked: false,
    visible: true,

    strokes: [],
    strokeWeight: 0,
    strokeAlign: "CENTER",
    strokeCap: "SQUARE",
    strokeJoin: "ROUND",
    dashPattern: [],
    cornerRadius: {
      bl: { unit: "px", value: 0 },
      br: { unit: "px", value: 0 },
      tl: { unit: "px", value: 0 },
      tr: { unit: "px", value: 0 },
    },

    fills: [],

    effects: [],
    alignHorizontal: "LEFT",
  };

  Object.assign(result, {
    ...fields,
    // fills가 빈배열이라면 기본값을 채워줌
    ...(fields?.fills?.length !== 3 && { fills: defaultPaint }),
  });

  return result;
};

export default createAutomatedProductListNode;
